import React, { ReactNode } from "react";
import classnames from "classnames"

type OnboardingPageContentProps = {
    children: ReactNode;
    hasStickyFooter?: boolean;
    centralizeContent?: boolean;
}

export const OnboardingPageContent = (props: OnboardingPageContentProps) => {
    const { hasStickyFooter, centralizeContent, children } = props;
    return <div className={classnames("onboarding-page__content", { "with-sticky-footer": hasStickyFooter, "centralize-content": centralizeContent })}>{children}</div>
}